import { ConversationView } from "../components/ConversationView";

export const ConversationPage = ({ id }: { id: string }) => (
  <ConversationView conversationId={id} />
);
